/**
 * The words lib/i18n.ts's `STRINGS` holds, in Swedish (Sweden), `sv` (SEO_BRIEF_10A section 4),
 * keyed by the same English. The rules are that module's and server/app/i18n_strings.py's:
 * `{name}` slots kept, no double quotes, product and format names as they are, and the two page
 * names (SUP to SRT, IDX/SUB to SRT) and the limit message said as the server table says them
 * (server/app/i18n_strings_sv.py). Not wired in here: the language joins `PageLang` and
 * `PAGE_LANGS` with the pages that use it.
 *
 * In the register the Swedish page copy uses, "du". NATIVE SPEAKER REVIEW RECOMMENDED, as for
 * the rest.
 */

export const SV: Readonly<Record<string, string>> = {
  "We need a quick check that you're a person. Tick the box below.":
    'Vi behöver snabbt kontrollera att du är en människa. Kryssa i rutan nedan.',
  'Getting ready…': 'Förbereder…',
  'a SUP/PGS subtitle file': 'en SUP/PGS-undertextfil',
  'a VobSub (IDX/SUB) subtitle file': 'en VobSub-undertextfil (IDX/SUB)',
  'SUP to SRT': 'SUP till SRT',
  'IDX/SUB to SRT': 'IDX/SUB till SRT',
  'YouTube video': 'YouTube-video',
  'TikTok video': 'TikTok-video',
  'Instagram video': 'Instagram-video',
  'Facebook video': 'Facebook-video',
  'X video': 'X-video',
  'Vimeo video': 'Vimeo-video',
  'Twitch video': 'Twitch-video',
  'Loom video': 'Loom-video',
  'Dailymotion video': 'Dailymotion-video',
  'Rumble video': 'Rumble-video',
  'LinkedIn video': 'LinkedIn-video',
  'Translated into {language}.': 'Översatt till {language}.',
  "1 line couldn't be translated and is left in {language}.":
    '1 rad kunde inte översättas och står kvar på {language}.',
  "{n} lines couldn't be translated and are left in {language}.":
    '{n} rader kunde inte översättas och står kvar på {language}.',
  "1 line couldn't be translated and is left as it was.":
    '1 rad kunde inte översättas och står kvar som den var.',
  "{n} lines couldn't be translated and are left as they were.":
    '{n} rader kunde inte översättas och står kvar som de var.',
  'This file is already in {language}.': 'Den här filen är redan på {language}.',
  podcast: 'podd',
  "Translation and summaries aren't available right now.":
    'Översättning och sammanfattningar är inte tillgängliga just nu.',
  "They'll be back by {reset}.": 'De är tillbaka senast kl. {reset}.',
  'Transcription still works.': 'Transkribering fungerar fortfarande.',
  'Chinese (Mandarin)': 'Kinesiska (mandarin)',
  // lib/rating-prompt.ts, the optional pop-up after a copy or a download.
  'How was this tool?': 'Vad tyckte du om verktyget?',
  '{n} out of 5': '{n} av 5',
  Bad: 'Dåligt',
  'Very good': 'Mycket bra',
  'Thanks for your rating.': 'Tack för ditt betyg.',
  Close: 'Stäng',
  // lib/option-panel.ts: the position grid, the colour's clear and its opacity.
  'Top left': 'Uppe till vänster',
  'Top centre': 'Uppe i mitten',
  'Top right': 'Uppe till höger',
  'Middle left': 'I mitten till vänster',
  'Middle centre': 'I mitten',
  'Middle right': 'I mitten till höger',
  'Bottom left': 'Nere till vänster',
  'Bottom centre': 'Nere i mitten',
  'Bottom right': 'Nere till höger',
  'Leave as the style sets it': 'Låt stilen bestämma',
  Opacity: 'Opacitet',
};
